import { useState } from "react"
import { YearSelector } from "../../core/shared/inputs/YearSelector"
import { MonthConstantsEditor } from "../RemoteAbstractAction/editors/MonthConstantsEditor"
import { BasicPage } from "../theme/Component/BasicPage"
import { _IncomeDocument, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { PrintJson } from "../theme/Component/PrintJson"
import { BasicButton } from "../theme/Component/BasicButton"
import { SelectIncomeStateConstant } from "../Treasury/IncomeDocument/Components/SelectIncomeStateConstant"
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable"
import { Modal } from "../theme/Component/Modal"
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal"
import { DropDown } from "../theme/Component/DropDown"
import AutoChart from "../../core/graph/AutoChart"

export const IncomeReport = () => {

    const { instance, setLista, lista, bean, setBean } = useDataBean(_IncomeDocument);
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());
    const [state, setState] = useState<number>(3);
    const modalGraph = useModal("Grafica", MODAL_XL);


    const getListaExport = () => {
        instance.getIncomeDocumentCatalog(year, month, null, null, null, state, null, null, null).then(
            (resp) => {
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityDoc = `${element.DataBeanProperties.Mnemonic ?? "N/A"} - ${element.DataBeanProperties.Consecutive ?? "N/A"}`
                    element.DataBeanProperties.EntityACMDoc = `${element.DataBeanProperties.ACMMnemonic ?? "N/A"} - ${element.DataBeanProperties.ACMConsecutive ?? "N/A"}`
                    element.DataBeanProperties.EntityBudget = `${element.DataBeanProperties.BudgetIDStr ?? "N/A"} - ${element.DataBeanProperties.BudgetIDName ?? "N/A"}`
                    element.DataBeanProperties.EntityAccountant = `${element.DataBeanProperties.AccountantIDStr ?? "N/A"} - ${element.DataBeanProperties.AccountantIDName ?? "N/A"}`
                });
                setLista(resp.List)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

     const head = [
        
         {title:'Fecha',property:'DocumentDate',visible:true,mask:MASK_DATE},        
        {title:'Concepto',property:'AccountantConceptName',visible:true},
        {title:'Descripcion',property:'Description',visible:true},                 
        {title:'Cuenta',property:'EntityAccountant',visible:true},        
        {title:'Estado',property:'StateName',visible:true},        
        {title:'Referencia 1 Siif',property:'Reference1',visible:true},        
        {title:'Referencia 2',property:'Reference2',visible:true},        
        {title:'Referencia 3',property:'Reference3',visible:true},        
        {title:'Documento Ingreso',property:'EntityDoc',visible:true},        
        {title:'Importe',property:'Value',visible:true,mask:MASK_MONEY},        
        {title:'Documento Compensacion',property:'EntityACMDoc',visible:true},        
        {title:'Rubro',property:'BudgetIDName',visible:true},        
    ]
     const actionsDropDown = [
                { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
            ];
            const buttons = () => {
                return (
                    <div className="row">
                        <div className="col-md-12">
                            <DropDown lista={actionsDropDown} eventClick={(e) => {
                                if (e.id == 1) {
                                    modalGraph.open();
                                }
                            }}></DropDown>
                        </div>
                    </div>
                )
            }

    return (
        <BasicPage titulo="Reporte de Ingresos">
            <div className="row">
                <div className="col-md-3">
                    <YearSelector tittle="Año" onChange={(e) => { setYear(parseInt(e)) }} value={year} />
                </div>
                <div className="col-md-3">
                    <MonthConstantsEditor name="" idSelect={month} onChange={(e) => { setMonth(parseInt(e)) }} label="Mes" />
                </div>
                <div className="col-md-3">
                    <SelectIncomeStateConstant idSelector={state} onChange={(e) => { setState(parseInt(e)) }} />
                </div>
                <div className="col-md-3 mt-4">
                    <BasicButton icon="" eventClick={getListaExport}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} head={head} body={lista} rowSet={setBean}></BasicTable>
                    {/* <PrintJson json={lista} /> */}
                     <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['AccountantConceptName', 'Rubro', 'DocumentDate','StateName']}
                            yOptions={['Value']} />

                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}